// extracted by mini-css-extract-plugin
export default {"container":"policyholderClaimRejectedForm_container__cZ4To"};